<template>
	<div id="app">
		<!-- 客服 首页头部 -->
		<div style="position: fixed;z-index: 999;top: 0;right: 0;background-color: white;width: 100%;">
			<div id="rightArrow" @click="moveLeftOrRight"
				:class="moveFlag?moveLeftRight==='left' ? 'animationLeftExpose':'animationRightExpose':''">
				<a href="javascript:;" title="在线客服"></a>
				<div class="arrowtxt">在线客服</div>
			</div>
			<!-- 左部客服弹出框 -->
			<div id="floatDivBoxs" :class="moveFlag?moveLeftRight==='left' ? 'animationLeft':'animationRight':''">
				<div class="floatDtt">在线客服</div>
				<div class="floatShadow">
					<ul class="floatDqq">
						<li>
							<a target="_blank"
								:href="'http://wpa.qq.com/msgrd?v=3&amp;uin='+QQnumberOne+'&amp;site=qq&amp;menu=yes'"><span>在线咨询</span></a>
						</li>
						<li>
							<a target="_blank"
								:href="'http://wpa.qq.com/msgrd?v=3&amp;uin='+QQnumberTwo+'&amp;site=qq&amp;menu=yes'"><span>在线咨询</span></a>
						</li>
						<li>
							<a target="_blank"
								:href="'http://wpa.qq.com/msgrd?v=3&amp;uin='+QQnumberThree+'&amp;site=qq&amp;menu=yes'"><span>在线咨询</span></a>
						</li>
					</ul>
					<div class="floatDtxt">服务热线</div>
					<ul class="floatDtel">
						<li><span class="icoTl">17310535369</span></li>
					</ul>
				</div>
				<div class="floatDbg"></div>
			</div>
			<!-- 页面头部 -->
			<div class="" style="height: 70px;">
				<div>
					<ul class="nav	w-1200">
						<a style="position: absolute;font-weight: bold;font-size: 2rem;color:black;">
							山西转型综合改革示范区职业技能等级认定平台
						</a>
						<!-- 公众号/登录/注册 -->
						<div style="position: absolute;right: 60px;">
							<li class="m" style="margin-left: 10px;">
								<a @mouseover="gzhMouseOver" @mouseleave="gzhMouseLeave"
									style="font-size: 17px;color:black;" class="layui-tel" href="javascript:;">
									<i class="layui-icon layui-icon-cellphone"></i>
									公众号
								</a>
								<div v-if="gzhFlag" class="hover_wrap"
									style="opacity:1;border-radius: 10px; top:75px;position: absolute; left: -70px; z-index: 999;background: #fff;border: 1px solid #ebeef5;box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);width: 220px;height: 240px;">
									<div>
										<div class="arrr f-pa"></div>
										<div style="text-align: center;width: 100%;height: 20px;margin-top: 10px;">微信扫一扫
										</div>
										<div style="width: 180px;height: 180px;margin: 0 auto">
											<img src="../../static/img/gongzhong.jpg" style="width: 100%;height: 100%;">
										</div>
									</div>
								</div>
							</li>
							<li class="m" style="margin-left: 50px;">
								<el-dropdown @command="loginHandleCommand"
									v-if="this.$storage.get('declareUser') == undefined">
									<a href="javascript:;" style="font-size: 17px;color:black;">
										<i class="layui-icon layui-icon-username"></i>
										登录<i class="el-icon-arrow-down el-icon--right"></i>
									</a>
									<el-dropdown-menu>
										<el-dropdown-item command="a">个人登录</el-dropdown-item>
										<el-dropdown-item command="b">单位登录</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>


								<el-dropdown @command="loginHandleCommand1"
									v-if="this.$storage.get('declareUser') != undefined">
									<a href="javascript:;" style="font-size: 17px;color:black;">
										<i class="layui-icon layui-icon-username"></i>
										{{this.$storage.get('declareUser').userName}}<i class="el-icon-arrow-down el-icon--right"></i>
									</a>
									<el-dropdown-menu>
										<el-dropdown-item command="b" style="text-align: center;">退出</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</li>
						</div>
					</ul>
				</div>
			</div>
		</div>
		<!-- 页面导航栏 -->
		<div class="" style="background: #014181;position: fixed;top:70px;z-index: 10;width: 100%;">
			<ul class="nav	w-1200" style="display: flex;width: 1300px;">
				<!-- 导航栏 -->
				<li v-for="(item,index) in NavigationLists" :key="index" :class="item.state == 1? 'm':'m on'"
					@click="navigationSwitchover(index)">
					<h3>
						<router-link :to="item.url" class="nav-f">{{item.name}}</router-link>
					</h3>
				</li>
			</ul>
		</div>
		<router-view></router-view>

		<end></end>
		<el-backtop>
		</el-backtop>
	</div>
	</div>
</template>
<script>
	//import homePage from './components/homePage.vue';
	import End from './end.vue';
	export default {
		name: 'app',
		components: {
			End
		},
		data() {
			return {
				NavigationLists: [
					{
						state: 2,
						url: '/HeddleChangeAreaHomePage',
						name: '首页'
					},
					{
						state: 1,
						url: '/',
						name: '太原理工大'

					}],
				gzhFlag: false,
				navigationName: '',
				flag: 0,
				drawer: false,
				moveFlag: false,
				moveLeftRight: '',
				declareUser: {}
			}
		},
		created() {
			this.declareUser = this.$storage.get('declareUser');
		},
		mounted() {
		},
		methods: {
			navigationSwitchover(index) {
				this.NavigationLists.forEach(element => {
					if (element.state == 2) {
						element.state = 1;
					}
				});
				this.NavigationLists[index].state = 2;
			},
			//登录
			loginHandleCommand(command) {
				if (command === 'a') {
					this.$router.push('/login')
				} else {
					this.$message('单位');
				}
			},
			//登录后
			loginHandleCommand1(command) {
				if (command === 'b') {
					//个人
					console.log('清除前的token==========' + this.$storage.get('token'));
					console.log('清除前的declareUser==========' + this.$storage.get('declareUser'));
					//退出登录
					this.$storage.remove('token');
					this.$storage.remove('declareUser');

					console.log('清除完后的token==========' + this.$storage.get('token'));
					console.log('清除完后的declareUser==========' + this.$storage.get('declareUser'));
					this.$router.push('/login');
				}
			},
			key() {
				return new Date().getTime;
			},
			//客服左移右移
			moveLeftOrRight() {
				if (this.moveLeftRight === '') {
					this.moveLeftRight = 'left';
				} else if (this.moveLeftRight === 'left') {
					this.moveLeftRight = 'right';
				} else {
					this.moveLeftRight = 'left';
				}
				this.moveFlag = true;//开启动画
			},
			//公众号鼠标移入
			gzhMouseOver() {
				this.gzhFlag = true;
			},
			//公众号鼠标移出
			gzhMouseLeave() {
				console.log("鼠标移出");
				this.gzhFlag = false;
			},

		}
	}
</script>
<style scoped>

.news_b, .w1200, .w-1200 {
    width: 1250px;
    margin: 0 auto;
    position: relative;
}
	.floatDbg {
		width: 120px;
		height: 20px;
		background: url(../../static/f/img/online_botbg.jpg) no-repeat;
	}

	.floatDtt {
		width: 120px;
		height: 45px;
		line-height: 45px;
		background: #00aeef;
		color: #fff;
		font-size: 18px;
		text-indent: 22px;
		position: relative;
	}

	#rightArrow {
		right: 120px;
		background-position: 0px 0px;
		width: 50px;
		height: 145px;
		background: url(../../static/f/img/online_arrow.jpg) no-repeat;
		position: fixed;
		top: 180px;
		right: -5px;
		z-index: 9999;
		background-position: -50px 0;
	}

	#floatDivBoxs {
		right: 0px;
		width: 120px;
		background: #fff;
		position: fixed;
		top: 180px;
		right: -125px;
		z-index: 999;
	}

	.animationLeftExpose {
		animation: moveLeftExpose 0.3s linear;
		animation-iteration-count: 1;
		animation-fill-mode: forwards;

	}

	.animationRightExpose {
		animation: moveRightExpose 0.3s linear;
		animation-iteration-count: 1;
		animation-fill-mode: forwards;

	}

	@keyframes moveLeftExpose {
		from {
			right: 0px;
		}

		to {
			right: 120px;
		}
	}

	@keyframes moveRightExpose {
		from {
			right: 120px;
		}

		to {
			right: 0px;
		}
	}

	.animationLeft {
		animation: moveLeft 0.3s linear;
		animation-iteration-count: 1;
		animation-fill-mode: forwards;

	}

	.animationRight {
		animation: moveRight 0.3s linear;
		animation-iteration-count: 1;
		animation-fill-mode: forwards;

	}

	@keyframes moveLeft {
		from {
			right: -120px;
		}

		to {
			right: 0px;
		}
	}

	@keyframes moveRight {
		from {
			right: 0px;
		}

		to {
			right: -120px;
		}
	}

	.a {
		position: absolute;
		left: 0;
		top: 65px;
		min-width: 100%;
		line-height: 36px;
		padding: 5px 0;
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12);
		border: 1px solid #d2d2d2;
		background-color: #fff;
		z-index: 100;
		border-radius: 2px;
		white-space: nowrap;
	}

	.bd {
		margin: 0 auto;
		width: 100% !important;
		position: relative;
		z-index: 0;
	}

	.mian {
		min-width: 1200px;
		padding-top: 15px;
	}

	.page_box {
		width: 100%;
		height: auto;
		overflow: hidden;
		margin: 0 auto;
		clear: both;
	}

	.page_box_right {
		width: 1200px;
		height: auto;
		overflow: hidden;
		margin: 0 auto;
	}

	#fitslist {
		padding: 0 15px;
		min-height: 400px;
	}

	#fitslist .index_6_2_1_4 {
		width: 100%;
		height: 110px;
		padding-bottom: 25px;
		border-bottom: #eeeeee solid 1px;
		margin-top: 15px;
		float: left;
	}

	#fitslist .index_6_2_1_4_2 {
		width: 980px;
		height: 110px;
		padding: 0 15px;
		float: left;
		line-height: 110px;
	}

	.clearfix {
		display: block;
		clear: both;
	}
</style>


// WEBPACK FOOTER //
// src/components/HeddleChangeArea.vue